import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./Navbar.css";

import greenlandLogo from "../../../assets/logo/greenland_footer.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import api from "../../../api/axios";
import { useSettings } from "../../../context/SettingsContext";
import { ADMINS } from "../../../constants/roles";
import { userHasAnyRole } from "../../../utils/leadershipRoles";

const Navbar = () => {
  const { globalSettings } = useSettings();

  const [mobileMenu, setMobileMenu] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const profileRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  // Robust check for user data
  const user =
    location.state?.user || JSON.parse(localStorage.getItem("user")) || null;
  const googleUser = JSON.parse(localStorage.getItem("googleUser"));
  // System Settings is an Admin / Superadmin page (the route and the API both refuse everyone else).
  const isAdmin = userHasAnyRole(user, ADMINS);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServicesDropdown(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("googleUser");
    navigate("/", { replace: true });
    window.location.reload();
  };

  const avatarSrc = user?.profile_photo_path
    ? `${api.defaults.baseURL}/${user.profile_photo_path}`
    : googleUser?.picture
      ? googleUser.picture
      : "/assets/images/users/avatar-1.jpg";

  return (
    <div className="new-nav-conatainer">
      <nav className="navbar">
        <div className="navbar-content">
          {/* Logo Section Updated */}
          <div className="nav-logo">
            <Link to="/">
              <img
                src={globalSettings?.logo ? globalSettings.logo : greenlandLogo}
                alt="Company Logo"
              />
            </Link>
          </div>

          {/* Mobile icon */}
          {!user && !googleUser && (
            <div
              className="mobile-icon"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              {mobileMenu ? <FaTimes size={24} /> : <FaBars size={24} />}
            </div>
          )}

          {/* Navigation Links */}
          <ul className={`nav-links ${mobileMenu ? "active" : ""}`}>
            <NavLink to={"/"}>HOME</NavLink>
            {/* ABOUT Dropdown Link */}
            <li
              className="nav-item-dropdown"
              onMouseEnter={() => setServicesDropdown(true)}
              onMouseLeave={() => setServicesDropdown(false)}
            >
              <div className="nav-link-with-arrow">
                ABOUT <MdKeyboardArrowDown size={18} />
              </div>

              <ul
                className={`nav-dropdown-menu ${servicesDropdown ? "show" : ""}`}
              >
                <li>
                  <NavLink to="/about">About Us</NavLink>
                </li>
                <li>
                  <NavLink to="/about/our-story">Our Story</NavLink>
                </li>
                <li>
                  <NavLink to="/about/mission-vision">Mission & Vision</NavLink>
                </li>
                <li>
                  <NavLink to="/about/our-managment-board">
                    All Directors
                  </NavLink>
                </li>
                {/* <li><NavLink to="/our-creative-experts">Our Creative Experts</NavLink></li> */}
                <li>
                  <NavLink to="/about/testimonial">Testimonial</NavLink>
                </li>
                <li>
                  <NavLink to="/about/why-choose-us">Why Choose Us</NavLink>
                </li>
                <li>
                  <NavLink to="/faq">FAQs</NavLink>
                </li>
              </ul>
            </li>

            <NavLink to="/greenland/properties">PROPERTIES</NavLink>
            <NavLink to="/gallery">GALLERY</NavLink>
            <NavLink to="/blogs">BLOGS</NavLink>
            <NavLink to="/faq">FAQ</NavLink>
            <NavLink to="/contact-us">CONTACT</NavLink>

            {/* Mobile Auth Buttons (only if NOT logged in) */}
            {!user && !googleUser && (
              <div className="auth-buttons auth-buttons-mobile">
                <Link to="/login" className="login-button">
                  Login
                </Link>
                <Link to="/register" className="register-button">
                  Register
                </Link>
              </div>
            )}
          </ul>

          {/* User Profile Section (Desktop/Tablet) */}
          {user || googleUser ? (
            <div className="topbar-action-item" ref={profileRef}>
              <div
                className="mobile-icon"
                onClick={() => setMobileMenu(!mobileMenu)}
              >
                {mobileMenu ? <FaTimes size={24} /> : <FaBars size={24} />}
              </div>
              <div
                className="user-info"
                onClick={() => setProfileDropdown(!profileDropdown)}
              >
                <img src={avatarSrc} alt="user" className="nav-avatar" />
                <div className="user-details">
                  <span className="user-name">
                    {user?.name || googleUser?.name || "User"}
                  </span>
                  <span className="user-role">{user?.mobile_number}</span>
                </div>
              </div>

              <div
                className={`dropdown-menu profile-menu-new ${profileDropdown ? "show" : ""}`}
              >
                <div className="dropdown-header">
                  Welcome {user?.name || googleUser?.given_name}!
                </div>
                <Link to="/profile" className="dropdown-item">
                  My Account
                </Link>
                {/* <Link to="/dashboard" className="dropdown-item">
                  Dashboard
                </Link> */}
                {isAdmin && (
                  <Link to="/system-settings" className="dropdown-item">
                    Settings
                  </Link>
                )}
                <div className="dropdown-divider"></div>
                <div
                  className="dropdown-item text-danger"
                  onClick={handleLogout}
                >
                  Logout
                </div>
              </div>
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="login-button">
                Login
              </Link>
              <Link to="/register" className="register-button">
                Register
              </Link>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
